var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"text-size-lg"},[_c('b-badge',{attrs:{"pill":"","variant":_vm.variant}},[_vm._v(_vm._s(_vm.value))])],1),(_vm.help)?_c('span',[_vm._v(" "+_vm._s(_vm.help)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }